<div class="min-h-screen bg-gray-900 py-8">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
      <div>
        <h1 class="text-3xl font-bold text-white">Berichten</h1>
        <p class="mt-1 text-sm text-gray-400">Beheer je nieuws- en blogberichten</p>
      </div>
      <div class="mt-4 sm:mt-0 flex gap-2">
        <button
          (click)="navigateToCategories()"
          class="inline-flex items-center px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white text-sm font-medium rounded-lg transition-colors">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z" />
          </svg>
          Categorieën
        </button>
        <button
          (click)="navigateToImport()"
          class="inline-flex items-center px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white text-sm font-medium rounded-lg transition-colors">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          WP Import
        </button>
        <button
          (click)="navigateToNew()"
          class="inline-flex items-center px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium rounded-lg transition-colors">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          Nieuw bericht
        </button>
      </div>
    </div>

    <!-- Language tabs -->
    <div class="mb-6 border-b border-gray-700" *ngIf="availableLanguages.length > 1">
      <nav class="flex gap-4">
        <button
          *ngFor="let lang of availableLanguages"
          type="button"
          (click)="setCurrentLanguage(lang.code)"
          class="px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors"
          [class.text-indigo-400]="currentLocale === lang.code"
          [class.border-indigo-400]="currentLocale === lang.code"
          [class.text-gray-400]="currentLocale !== lang.code"
          [class.border-transparent]="currentLocale !== lang.code"
          [class.hover:text-gray-300]="currentLocale !== lang.code">
          {{ getLanguageName(lang.code) }}
        </button>
      </nav>
    </div>

    <!-- Search, domain and category filter -->
    <div class="mb-6 flex flex-col sm:flex-row gap-4">
      <div class="relative flex-1 max-w-md">
        <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          type="text"
          [(ngModel)]="filterText"
          (ngModelChange)="onFilterChange()"
          placeholder="Zoek berichten..."
          class="w-full pl-10 pr-4 py-2.5 bg-gray-800 border border-gray-700 rounded-lg text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
      </div>
      <div class="w-full sm:w-56">

        <select
          [(ngModel)]="filterDomain"
          (ngModelChange)="onDomainFilterChange()"
          class="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
          <option [ngValue]="null">Alle domeinen</option>
          <option *ngFor="let d of domains" [ngValue]="d.name">{{ d.name }}</option>
        </select>
      </div>
      <div class="w-full sm:w-56" *ngIf="filterDomain">
        <label class="block text-xs text-gray-500 mb-1">Categorie</label>
        <select
          [(ngModel)]="filterCategoryId"
          (ngModelChange)="onCategoryFilterChange()"
          class="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
          <option [ngValue]="null">Alle categorieën</option>
          <option [ngValue]="'uncategorized'">Ongecategoriseerd</option>
          <option *ngFor="let c of categories" [ngValue]="c.id">{{ c.name }}</option>
        </select>
        <div class="mt-2" *ngIf="filterDomain">
          <button
            *ngIf="!showNewCategoryInput"
            type="button"
            (click)="showNewCategoryInput = true"
            class="text-xs text-indigo-400 hover:text-indigo-300">
            + Categorie toevoegen
          </button>
          <div *ngIf="showNewCategoryInput" class="flex flex-col gap-2 mt-2 sm:flex-row sm:items-center">
            <input
              type="text"
              [(ngModel)]="newCategoryName"
              (keydown.enter)="addCategory(); $event.preventDefault()"
              placeholder="Naam"
              class="flex-1 min-w-0 px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-gray-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent" />
            <div class="flex gap-1">
              <button type="button" (click)="addCategory()" class="px-3 py-2 bg-indigo-600 text-white text-sm rounded-lg hover:bg-indigo-500">
                Toevoegen
              </button>
              <button type="button" (click)="cancelNewCategory()" class="px-3 py-2 bg-gray-600 text-gray-200 text-sm rounded-lg hover:bg-gray-500">
                Annuleren
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading bar bovenaan -->
    <div *ngIf="loading" class="mb-4 w-full h-1 bg-gray-800 rounded-full overflow-hidden">
      <div class="h-full bg-indigo-500 rounded-full animate-pulse" style="width: 60%"></div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && filteredPosts.length === 0" class="text-center py-20">
      <svg class="mx-auto h-16 w-16 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
      </svg>
      <h3 class="mt-4 text-lg font-medium text-gray-200">Geen berichten gevonden</h3>
      <p class="mt-2 text-sm text-gray-400">
        Geen berichten in {{ getLanguageName(currentLocale) }}. Maak een nieuw bericht aan of wissel van taal.
      </p>
      <button
        (click)="navigateToNew()"
        class="mt-4 inline-flex items-center px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium rounded-lg transition-colors">
        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        Nieuw bericht
      </button>
    </div>

    <!-- Table -->
    <div *ngIf="!loading && filteredPosts.length > 0" class="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden">
      <table class="w-full table-fixed">
        <colgroup>
          <col />
          <col class="hidden xl:table-column w-[16%]" />
          <col class="hidden lg:table-column w-[10%]" />
          <col class="w-[9%]" />
          <col class="hidden md:table-column w-[14%]" />
          <col class="w-[9%]" />
          <col class="w-[7%]" />
        </colgroup>
        <thead class="bg-gray-900/50">
          <tr>
            <th class="px-3 py-4 text-left">
              <button (click)="onSort('title')" class="flex items-center text-xs font-semibold text-gray-400 uppercase tracking-wider hover:text-white">
                Bericht
                <svg class="w-4 h-4 ml-1 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="getSortIcon('title')" />
                </svg>
              </button>
            </th>
            <th class="hidden xl:table-cell px-3 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider">Slug</th>
            <th class="hidden lg:table-cell px-3 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider">Domeinen</th>
            <th class="px-3 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider">Status</th>
            <th class="hidden md:table-cell px-3 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider">Categorie</th>
            <th class="px-3 py-4 text-left">
              <button (click)="onSort('date')" class="flex items-center text-xs font-semibold text-gray-400 uppercase tracking-wider hover:text-white">
                Datum
                <svg class="w-4 h-4 ml-1 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="getSortIcon('date')" />
                </svg>
              </button>
            </th>
            <th class="px-3 py-4 text-right text-xs font-semibold text-gray-400 uppercase tracking-wider">Acties</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-700">
          <tr *ngFor="let post of filteredPosts"
              class="hover:bg-gray-700/50 transition-colors cursor-pointer"
              (click)="navigateToEdit(post)">
            <td class="px-3 py-4">
              <div class="flex items-center min-w-0">
                <div class="w-10 h-10 rounded-lg bg-gray-700 flex-shrink-0 overflow-hidden mr-3">
                  <img *ngIf="post.featuredImage" [src]="post.featuredImage" [alt]="getPostTitle(post)" class="w-full h-full object-cover">
                  <div *ngIf="!post.featuredImage" class="w-full h-full flex items-center justify-center">
                    <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                </div>
                <div class="min-w-0 flex-1">
                  <div class="text-sm font-medium text-white truncate">{{ getPostTitle(post) }}</div>
                </div>
              </div>
            </td>
            <td class="hidden xl:table-cell px-3 py-4 text-sm text-gray-400 truncate" [title]="'/' + (post.slug || '-')">/{{ post.slug || '-' }}</td>
            <td class="hidden lg:table-cell px-3 py-4 text-sm text-gray-400 truncate" [title]="getPostDomainsDisplay(post)">{{ getPostDomainsDisplay(post) }}</td>
            <td class="px-3 py-4">
              <span
                class="inline-block px-2 py-1 text-xs font-medium rounded-full whitespace-nowrap"
                [ngClass]="{
                  'bg-green-900/50 text-green-300': post.status === 'published',
                  'bg-yellow-900/50 text-yellow-300': post.status === 'draft'
                }">
                {{ post.status === 'published' ? 'Gepubliceerd' : 'Concept' }}
              </span>
            </td>
            <td class="hidden md:table-cell px-3 py-4 text-sm text-gray-300 truncate" [title]="getCategoryNames(post)">{{ getCategoryNames(post) }}</td>
            <td class="px-3 py-4 text-sm text-gray-400 whitespace-nowrap">{{ getPostDate(post) | date:'d MMM y' }}</td>
            <td class="px-3 py-4" (click)="$event.stopPropagation()">
              <div class="flex items-center justify-end gap-1">
                <button
                  (click)="navigateToEdit(post)"
                  class="p-1.5 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors"
                  title="Bewerken">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </button>
                <button
                  (click)="openDeleteModal(post)"
                  class="p-1.5 text-gray-400 hover:text-red-400 hover:bg-red-400/10 rounded-lg transition-colors"
                  title="Verwijderen">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Delete post modal -->
<app-confirm-modal
  [show]="showDeletePostModal"
  title="Bericht verwijderen"
  [message]="'Weet je zeker dat je \'' + (postToDelete ? getPostTitle(postToDelete) : '') + '\' wilt verwijderen? Alle taalversies worden verwijderd. Deze actie kan niet ongedaan worden gemaakt.'"
  (onConfirm)="deletePost()"
  (onCancel)="closeDeleteModal()">
</app-confirm-modal>

<app-notification></app-notification>
